import React, { ReactNode } from 'react'
import { Hidden as MHidden, HiddenProps as MHiddenProps } from '@material-ui/core'

export type HiddenProps = MHiddenProps & {
  children: ReactNode
}

export default function Hidden (props: HiddenProps) {
  return (
    <MHidden {...props}/>
  )
}
